// extracted by mini-css-extract-plugin
export default {"container":"LoadingScreen_container__kHmhS","hover-animation":"LoadingScreen_hover-animation__Og3pr"};